"use client";
import {
  image_default
} from "./chunk-YAC6J4IU.mjs";
import {
  useImage
} from "./chunk-6MTUP564.mjs";
export {
  image_default as Image,
  useImage
};
